import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import React, { useEffect, useState } from 'react';
import { FilterOptionValue, MappedFacet } from '@mybestbrands/types';
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';

export function SizesFilter({
  filter,
  isActive,
  toggleFilterOptions,
  onFilterUpdate,
  onApplySearchFilters,
}: {
  filter: FilterOptionValue | undefined;
  onFilterUpdate: (value: string[]) => void;
  isActive: boolean;
  toggleFilterOptions: (val: boolean) => void;
  onApplySearchFilters: () => void;
}) {
  const { t } = useTranslation('filters');

  const [filterOptions, setFilterOptions] = useState([] as MappedFacet[]);

  const selectedSizes = filterOptions.filter((option) => option.checked).map((option) => option.value);

  useEffect(() => {
    if (!filter) return;
    setFilterOptions(filter.options);
  }, [filter?.options]);

  const Chevron = isActive ? ChevronUp : ChevronDown;

  if (!filter || !filter.options.length) return null;

  function onSizeSelect(id: string) {
    const newFilterOptions = filterOptions.map((option) => {
      return option.id === id ? { ...option, checked: !option.checked } : option;
    });

    setFilterOptions(newFilterOptions);
    const selectedSizes = newFilterOptions.filter((option) => option.checked).map((option) => option.value);

    onFilterUpdate(selectedSizes);
  }

  return (
    <div
      key={filter.name}
      className="position-relative"
      style={{
        zIndex: 3,
      }}>
      <div
        onClick={() => toggleFilterOptions(!isActive)}
        key={filter.name}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span className="me-1">{t(filter.name)}</span>
        {!!selectedSizes.length && (
          <span className={`${styles.filtercounter}`}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {selectedSizes.length}
            </span>
          </span>
        )}
        <Chevron className="ms-2" />
      </div>
      {isActive && (
        <div className={`position-absolute bg-white border border-dark p-2 filter-list`} style={{ top: '35px' }}>
          <div className={`d-flex flex-wrap ${styles.sizescontainer}`} style={{ gap: '0.3rem', paddingBottom: 1 }}>
            {filterOptions.map((option) => (
              <button
                onClick={() => onSizeSelect(option.id)}
                key={option.id}
                className={`${clsx(
                  'btn small',
                  styles.sizeoption,
                  option.checked ? 'btn-black' : 'btn-white-hover-border'
                )}`}>
                <span style={{ whiteSpace: 'nowrap' }}>{option.name}</span>
              </button>
            ))}
          </div>
          <div className="position-relative">
            <button
              onClick={onApplySearchFilters}
              className="btn filter btn-white-hover-black lowercase mt-3 mb-2 w-100">
              {t('SAVE')}
              <span className="ms-1" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
